<script>
import DataLabel from '@/js/components/common/labels/DataLabel';

export default {
    name: 'LoadingLabel',

    functional: true,

    props: {
        isLoading: {type: Boolean},
    },

    render(createElement, {props, data, parent}) {
        if (!props.isLoading) {
            return null;
        }

        data.staticClass = ['font-italic', data.staticClass].join(' ');

        data.props = {
            item: parent.$t('common.labels.loading.nil'),
            iconClass: 'fa fa-fw fa-spin fa-spinner',
            none: parent.$t('common.labels.loading.nil'),
        };

        return createElement(DataLabel, data);
    },
};
</script>
